export default __webpack_public_path__ + "static/media/how-1.b5b2e615.PNG";